























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { PayrollValidationMessageType } from "@/employer/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import { usePayrollCalendarStore } from "@/employer/store/payrollCalendar";
import { useThemeStore } from "@/shared/store/theme";

@Component ({
  components: {
    GenericLoadingSpinner,
    Button,
  }
})
export default class PayrollEditSummaryModal extends Vue {
  @Prop({required: true})
  shouldShow: boolean;

  payrollCalendarStore = usePayrollCalendarStore();
  themeStore = useThemeStore();

  emptyBlockErrorWorkaround = false;

  get isVisible () {
    return this.shouldShow;
  }
  // required to avoid vue warning for computed property without setter
  // has to put some content in the block due to a linter error
  set isVisible (newValue) {
    this.emptyBlockErrorWorkaround = newValue;
  }

  get isLoaded () {
    return !this.shouldShow || this.payrollCalendarStore.validationFetchState === FetchState.Loaded;
  }

  get warningMessages () {
    return this.payrollCalendarStore.validationMessages.filter(v => v.messageType === PayrollValidationMessageType.Warning)
      .map(v => `Warning: ${v.message}`);
  }

  get dateChangeMessages () {
    return this.payrollCalendarStore.validationMessages.filter(v => v.messageType === PayrollValidationMessageType.DateChange)
      .map(v => v.message);
  }

  onCancel () {
    this.$emit("cancel");
  }

  onSubmit () {
    this.$emit("confirm");
  }

  @Watch("isLoaded")
  onLoaded (isLoaded) {
    // automatically dismiss the dialog due to no content
    if (isLoaded && this.shouldShow && this.payrollCalendarStore.validationMessages.length === 0) {
      this.onSubmit();
    }
  }
}
